import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getCourseBlogById } from "../helper/apicalls/courseBlog";
import Content from "../components/Content";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "../styles/CurrentAffairsDetail.scss";
import GlobalLoader from "../components/GlobalLoader";

const CurrentAffairsDetail = () => {
  const { blogId } = useParams();
  const navigate = useNavigate();
  const [blogData, setBlogData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogDetails = async () => {
      if (!blogId) return;

      try {
        setLoading(true);
        setError(null);
        const res = await getCourseBlogById(blogId);
        const data = res?.data || res;
        setBlogData(data);
      } catch (err) {
        console.error("Failed to fetch blog details", err);
        setError("Failed to load blog details. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchBlogDetails();
  }, [blogId]);

  const handleBack = () => {
    navigate(-1);
  };

  const formatContentForComponent = (blog) => {
    if (!blog) return [];

    const contentArray = [];

    if (blog.image_url) {
      contentArray.push({
        id: `${blog.id || blog._id}-image`,
        content: `![${blog.title || "Blog Image"}](${blog.image_url})`,
        type: "content",
      });
    }

    if (blog.description || blog.blog_description) {
      contentArray.push({
        id: `${blog.id || blog._id}-description`,
        content: `## Overview\n\n${blog.description || blog.blog_description}`,
        type: "content",
      });
    }

    if (blog.content_html) {
      contentArray.push({
        id: blog.id || blog._id,
        content: blog.content_html,
        type: "content",
      });
    } else if (blog.content) {
      contentArray.push({
        id: blog.id || blog._id,
        content: blog.content,
        type: "content",
      });
    }

    return contentArray;
  };

  if (loading) {
    return (
      <div className="current-affairs-detail">
        <GlobalLoader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="current-affairs-detail">
        <div className="detail-error">
          <p>{error}</p>
          <button onClick={handleBack} className="back-button">
            Go Back
          </button>
        </div>
      </div>
    );
  }

  if (!blogData) {
    return (
      <div className="current-affairs-detail">
        <div className="detail-error">
          <p>Blog not found.</p>
          <button onClick={handleBack} className="back-button">
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="current-affairs-detail custom-scrollbar">
      <div className="detail-header">
        <div className="header-content">
          <ArrowBackIcon onClick={handleBack} style={{ cursor: "pointer" }} />
          <h1 className="detail-title">
            {blogData.title || blogData.name || "Blog Details"}
          </h1>
        </div>
      </div>

      <div className="detail-scroll-container custom-scrollbar">
        <div className="single-blog-card">
          {blogData.image_url && (
            <div className="blog-image-container">
              <img
                src={blogData.image_url}
                alt={blogData.title || "Blog Image"}
                className="blog-image"
              />
            </div>
          )}

          <div className="card-content-padding">
            {(blogData.created_at || blogData.updated_at) && (
              <div className="blog-meta-info">
                {blogData.created_at && (
                  <span className="meta-date">
                    Published:{" "}
                    {new Date(blogData.created_at).toLocaleDateString()}
                  </span>
                )}
                {blogData.updated_at && (
                  <span className="meta-date">
                    Updated:{" "}
                    {new Date(blogData.updated_at).toLocaleDateString()}
                  </span>
                )}
              </div>
            )}

            {blogData.blog_description && (
              <div className="blog-summary-section">
                <p>{blogData.blog_description}</p>
              </div>
            )}

            <div className="blog-main-description">
              <Content
                content={[
                  {
                    content: blogData.description || blogData.content || "",
                    type: "content",
                  },
                ]}
                handleCompletedClick={() => {}}
                isMarkAsComplete={false}
                setIsMarkAsComplete={() => {}}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentAffairsDetail;
